export const ENDPOINT_AUTH_LOGIN = '/api/auth/sign-in';
export const ENDPOINT_AUTH_ME = '/api/auth/get-current-user';
